// extracted by mini-css-extract-plugin
export var centerText = "_dm-8";
export var container = "_dm-0";
export var doughnutContainer = "_dm-7";
export var legend = "_dm-a";
export var legendItemColorDisplay = "_dm-b";
export var legendItemLabel = "_dm-d";
export var legendItemValue = "_dm-c";
export var lg = "_dm-5";
export var maxWidth = "_dm-9";
export var md = "_dm-4";
export var responsive = "_dm-6";
export var sm = "_dm-3";
export var xs = "_dm-2";
export var xxs = "_dm-1";